// SortBox.js

import {
    defineComponent,
    computed,
    inject,
} from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "SortBox",
    inject: ["filteredDataCount"],
    emits: ["update:filters"],
    setup(props, { emit }) {
        const sorts = inject("allProductsorts");

        const sortDate = () => {
            if (sorts.value.date.active) {
                sorts.value.date.sort =
                    sorts.value.date.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.date.active = true;
            sorts.value.price.active = false;
            sorts.value.day.active = false;
        };
        const sortPrice = () => {
            if (sorts.value.price.active) {
                sorts.value.price.sort =
                    sorts.value.price.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.price.active = true;
            sorts.value.date.active = false;
            sorts.value.day.active = false;
        };
        const sortDay = () => {
            if (sorts.value.day.active) {
                sorts.value.day.sort =
                    sorts.value.day.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.day.active = true;
            sorts.value.date.active = false;
            sorts.value.price.active = false;
        };

        return {
            sorts,
            sortDate,
            sortPrice,
            sortDay,
        };
    },

    template: html`
        <div class="sort_box">
            <div class="sort_btn_list">
                <button
                    class="sort_btn"
                    @click="sortDate"
                    :class="{'active':sorts.date.active}"
                >
                    日期近到遠
                    <div class="">
                        <i
                            class="fa-solid"
                            :class="{'fa-arrow-up-wide-short':sorts.date.sort === 'asc','fa-arrow-down-wide-short':sorts.date.sort === 'desc'}"
                        ></i>
                    </div>
                </button>
                <div class="line"></div>
                <button
                    class="sort_btn"
                    @click="sortPrice"
                    :class="{'active':sorts.price.active}"
                >
                    依價格
                    <div class="">
                        <i
                            class="fa-solid"
                            :class="{'fa-arrow-up-wide-short':sorts.price.sort === 'asc','fa-arrow-down-wide-short':sorts.price.sort === 'desc'}"
                        ></i>
                    </div>
                </button>
                <div class="line"></div>
                <button
                    class="sort_btn"
                    @click="sortDay"
                    :class="{'active':sorts.day.active}"
                >
                    依天數
                    <div class="">
                        <i
                            class="fa-solid"
                            :class="{'fa-arrow-up-wide-short':sorts.day.sort === 'asc','fa-arrow-down-wide-short':sorts.day.sort === 'desc'}"
                        ></i>
                    </div>
                </button>
            </div>
        </div>
    `,
    methods: {},
});
